import { useRouter } from 'next/router';
import { useContext } from 'react';
import ContentResultsResearch from '@/srp/ContentResultsResearch/ContentResultsResearch';
import HideOnNative from '@/srp/HideOnNative';
import Modals from '@/srp/Modals';
import PromoBanner from '@/srp/PromoBanner';
import DeliveryBannerWrapper from '@/srp/Search/components/DeliveryBannerWrapper';
import { ResultsSection } from '@/srp/SearchResults/ResultsSection';
import BreadCrumbs from '@/srp/SEO/BreadCrumbs';
import CreditKarmaPromoBanner from '~/components/common/CreditKarmaPromoBanner';
import { useConfiguration } from '~/context/common/StaticContext';
import ModalContext from '~/context/srp/ModalContext';
import { useTrackRendered } from '~/hooks/common';
import useRefToSetGetItBy from '~/hooks/srp/useRefToSetGetItBy';
import NativeError from '~/native/srp/NativeError';
import BackgroundOverlay from './BackgroundOverlay';
import Filters from './Filters';
import { Container, FiltersResultsContainer, Main } from './MainLayout.styles';
import { SearchHeader, SearchTools } from './SearchHeader';
import MenuOptions from './SearchHeader/MenuOptions';
import StickyHeaderWaypoint from './SearchHeader/StickyHeaderWaypoint';

function useDisableSeo() {
  const { disableSeoLinks } = useConfiguration();
  const { pathname } = useRouter();

  return disableSeoLinks || pathname.includes('/cars/st');
}

export default function MainLayout({ initialSeoProps }) {
  const ref = useRefToSetGetItBy();
  const disableSeo = useDisableSeo();
  const { setCreditKarmaPromoModalOpen } = useContext(ModalContext);

  useTrackRendered('car-merch-megafire');

  return (
    <div className="relative m-auto max-w-[1800px]">
      <BackgroundOverlay />
      <NativeError />
      <CreditKarmaPromoBanner
        setCreditKarmaPromoModalOpen={setCreditKarmaPromoModalOpen}
      />
      <DeliveryBannerWrapper />
      <StickyHeaderWaypoint />
      <Container>
        <FiltersResultsContainer>
          <Filters />
          <Main>
            <SearchHeader />
            <MenuOptions />
            <SearchTools />
            <div ref={ref} className="z-0 bg-grey-1 p-16 m:bg-white m:p-0">
              <PromoBanner />
              <ResultsSection />
            </div>
          </Main>
        </FiltersResultsContainer>
        <HideOnNative>
          <div className="w-100 mt-32 flex h-[84px] flex-col bg-white">
            <div className="w-100 flex h-[100%] flex-col justify-center">
              <BreadCrumbs />
            </div>
          </div>
        </HideOnNative>
      </Container>
      <Modals />
      <HideOnNative>
        {disableSeo ? null : (
          <ContentResultsResearch initialSeoProps={initialSeoProps} />
        )}
      </HideOnNative>
    </div>
  );
}
